var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.device_data)?_c('v-skeleton-loader',{staticClass:"mx-10 my-4",attrs:{"type":"image"}}):_c('div',{staticClass:"container pa-0",attrs:{"id":`con_${_vm.id}`}},[_c('div',{staticClass:"svg-container",attrs:{"id":`${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }